export default "__VITE_ASSET__CjC06yHA__"